import React from "react";
export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(({ className = "", ...props }, ref) => (
  <textarea ref={ref} className={`flex min-h-[80px] w-full rounded-md border bg-background px-3 py-2 text-sm ${className}`} {...props} />
));
Textarea.displayName = "Textarea";
